import { render, staticRenderFns } from "./BuyInLimitation.vue?vue&type=template&id=147953f1&scoped=true"
import script from "./BuyInLimitation.vue?vue&type=script&lang=js"
export * from "./BuyInLimitation.vue?vue&type=script&lang=js"
import style0 from "./BuyInLimitation.vue?vue&type=style&index=0&id=147953f1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147953f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147953f1')) {
      api.createRecord('147953f1', component.options)
    } else {
      api.reload('147953f1', component.options)
    }
    module.hot.accept("./BuyInLimitation.vue?vue&type=template&id=147953f1&scoped=true", function () {
      api.rerender('147953f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/account/components/BuyInLimitation.vue"
export default component.exports